module.exports = __webpack_public_path__ + "img/1115.55e308d1.jpg";